import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { getFileNameFromUrl, myAxios } from "../common/functions";
import { saveAs } from "file-saver";
import { LoaderData, ReportListItem, JobTagForm, timeCardStatus, weeknum } from "./types";
import { DetailLoaderData, ListLoaderData } from "./types";
export async function timeCardLoader({ params }: LoaderFunctionArgs): Promise<LoaderData | Response> {
    const { week:potentialWeek } = params as { week?: string };
    if (!potentialWeek) {
        throw redirect(`/TimeCard/${weeknum(new Date())}`);
    }
    const formData = new FormData();
    formData.append("week", potentialWeek ?? "");
    const [resReports, res] = await Promise.all([
        myAxios({ fileName: "timeCard/readReports.php" }),
        myAxios({ fileName: "timeCard/readTimeCard.php", formData }),
    ]);
    if(!res || !resReports) throw redirect("..");
    const reportsList: ReportListItem[] = resReports?.data?.map((item: ReportListItem) =>
        item.startDate && item.endDate
            ? { ...item, label: `${item.label} ${item.startDate} ~ ${item.endDate}` }
            : item
    ) ?? [];
    const {data, week, weeks} = res.data;
    let working = false;
    if (data) {
        const dayIndex = (new Date()).getDay() === 0 ? 6 : (new Date()).getDay() - 1;
        const currentDay = data.form[dayIndex];
        if (currentDay.inOut.length) {
            working = !currentDay.inOut[currentDay.inOut.length - 1].out;
        }
    }
    return { data, reportsList, working, week, weeks };
}
export async function timeCardUpdateTime({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/updateTime.php", formData });
    throw redirect("..");
}
export async function timeCardUpdateContent({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/updateContent.php", formData });
    throw redirect("..");
}
export async function timeCardSubmit({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/submit.php", formData });
    throw redirect("..");
}
export async function timeCardPunch({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/punch.php", formData });
    throw redirect("..");
}

export async function timeCardDownload({ request }: ActionFunctionArgs) { // not right
    const formData = await request.formData();
    const res = await myAxios({ fileName: "server/fileStorage.php", formData });
    if (!res) return;
    const url = res.data;
    try{
        const response = await fetch(url);
        if(!response.ok) throw new Error("Failed to fetch file");
        saveAs(await response.blob(), getFileNameFromUrl(url)!);
        // throw redirect("..");
    }catch(error){
        window.alert("Error downloading file:" + error);
    }
}

/* -------- Approval ------------ */
export async function allTimeCardsListLoader({ request, params }: LoaderFunctionArgs): Promise<ListLoaderData | Response> {
    const { week } = params as { week?: string };
    if (!week) {
        throw redirect(`/AllTimeCards/${weeknum(new Date())}`);
    }
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    const statusParam = url.searchParams.get("status");
    let shouldRedirect = false;
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (statusParam !== null && !timeCardStatus.includes(statusParam)) {
        url.searchParams.delete("status");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const status = url.searchParams.get("status") ?? "";
    const formData = new FormData();
    formData.append("week", week);
    formData.append("page", String(page));
    formData.append("limit", String(limit));
    if(status !== "") formData.append("status", status);
    const res = await myAxios({ fileName: "timeCard/readAllTimeCards.php", formData });
    if(!res) throw redirect("/");
    const { timeCards, week: resolvedWeek, weeks, total } = res.data;
    return {
        status,
        users: timeCards,
        week: resolvedWeek,
        weeks,
        total
    };
}
export async function allTimeCardsDetailLoader({ params }: LoaderFunctionArgs): Promise<DetailLoaderData | Response> {
    const { week, userId } = params as { week: string; userId: string };
    const formData = new FormData();
    formData.append("week", week);
    formData.append("employeeId", userId);
    const [resReports, res] = await Promise.all([
        myAxios({ fileName: "timeCard/readReports.php" }),
        myAxios({ fileName: "timeCard/readOneTimeCard.php", formData }),
    ]);
    if(!res) throw redirect("..");
    const reportsList: ReportListItem[] = resReports?.data?.map((item: ReportListItem) =>
        item.startDate && item.endDate
            ? { ...item, label: `${item.label} ${item.startDate} ~ ${item.endDate}` }
            : item
    ) ?? [];
    const data: JobTagForm = res.data;
    return { data, reportsList, week };
}
export async function allTimeCardsUpdateTimeAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/updateOneTimeCard.php", formData });
    throw redirect("..");
}
export async function allTimeCardsApprovalAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "timeCard/approval.php", formData });
    throw redirect("..");
}

export async function timeCardExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    const res = await myAxios({
        fileName: "/timeCard/export.php",
        formData, 
        responseType: "blob",
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "Time Cards.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}